import React, { useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

import { Image, Row, S, Tooltip } from './styles';
import { FlagIcon } from '../../../../../components/Icons';
import { useFlag } from '@unleash/proxy-client-react';

import Cautelar from '../../../../../images/icons/badge_cautelar_aprovada.svg';
import CautelarInstaCarro from '../../../../../images/icons/badge_instacarro_cautelar_aprovada.svg';
import Km from '../../../../../images/icons/km.svg';
import Longarina from '../../../../../images/icons/badge_longarina.svg';
import Colunas from '../../../../../images/icons/badge_colunas.svg';
import Cambio from '../../../../../images/icons/badge_cambio.svg';
import Scanner from '../../../../../images/icons/badge_scanner.svg';
import { checkItemsToHaveDivider } from '../../../../../utils/details';
import BadgePneus from '../../../../../images/icons/badge_pneus.svg'; // Novo ícone para pneus
import BadgeInterior from '../../../../../images/icons/badge_interior.svg'; // Novo ícone para conservação do interior
import BadgeGNV from '../../../../../images/icons/badge_gnv.svg'; // Novo ícone para GNV

function sortbyImages(items) {
  const photos = [];
  const texts = [];
  items.map(el => (el.img && el.img.src ? photos.push(el) : texts.push(el)));
  return { photos: photos, texts: texts };
}

function sortbyImages2(items) {
  const photos = [];
  const texts = [];
  items.map(el => (el.label && el.label.includes('Foto') ? photos.push(el) : texts.push(el)));
  return { photos: photos, texts: texts };
}

export const Content = ({
  title,
  items,
  auction,
  onGallery,
  isOptional = false,
  collapsed = false,
  useNewSort = false,
  useNewLayout = false,
}) => {
  const sortedItems = useNewSort ? sortbyImages2(items) : sortbyImages(items);
  const [opened, setOpened] = useState(collapsed);

  const flagBadgeCautelar = useFlag('badge-cautelar');
  const flagBadgeLongarina = useFlag('badge-longarina');
  const flagBadgeColunas = useFlag('badge-colunas');
  const flagBadgeKm = useFlag('badge-km');
  const flagBadgeCambio = useFlag('badge-cambio');
  const flagBadgeScanner = useFlag('badge-scanner');
  const flagBadgePneus = useFlag('badge-pneus'); // Nova flag para badge de pneus
  const flagBadgeInterior = useFlag('badge-interior'); // Nova flag para badge de conservação do interior
  const flagBadgeGNV = useFlag('badge-gnv'); // Nova flag para badge de GNV

  const shouldShowCautelar = auction?.vehicle?.precautionaryReport && flagBadgeCautelar;
  const shouldShowLongarina =
    auction?.vehicle?.canHaveCarSparBadge && flagBadgeLongarina && !shouldShowCautelar;
  const shouldShowColunas =
    auction?.vehicle?.canHaveColumnBadge && flagBadgeColunas && !shouldShowCautelar;
  const shouldShowBomKm = auction?.vehicle?.kilometrageAcceptable && flagBadgeKm;
  const shouldShowCambio = auction?.vehicle?.canHaveTransmissionBadge && flagBadgeCambio;
  const shouldShowScanner = auction?.vehicle?.canHaveScannerBadge && flagBadgeScanner;
  // Nova lógica para badge de pneus
  const shouldShowPneus = auction?.vehicle?.canHaveTiresBadge && flagBadgePneus;

  // Nova lógica para badge de conservação do interior
  const shouldShowInterior = auction?.vehicle?.canHaveInteriorBadge && flagBadgeInterior;

  // Nova lógica para badge de GNV
  const shouldShowGNV = auction?.vehicle?.canHaveGNVBadge && flagBadgeGNV;

  const BADGE_TYPES = {
    Estrutura: ['BadgeCautelar', 'BadgeLongarina', 'BadgeColunas', 'BadgeBomKm'],
    Mecânica: ['BadgeCambio', 'BadgeScanner', 'BadgeGNV'],
    Visual: ['BadgeInterior'], // Nova categoria Visual para badge de conservação do interior
    // Removendo a categoria separada "Pneus" - a badge deve aparecer na seção "Rodas e Pneus"
  };

  const BADGE_STATUS = {
    BadgeCautelar: shouldShowCautelar,
    BadgeLongarina: shouldShowLongarina,
    BadgeColunas: shouldShowColunas,
    BadgeBomKm: shouldShowBomKm,
    BadgeCambio: shouldShowCambio,
    BadgeScanner: shouldShowScanner,
    BadgeInterior: shouldShowInterior, // Nova badge de conservação do interior
    BadgeGNV: shouldShowGNV, // Nova badge de GNV
    // Removendo BadgePneus daqui - será tratada separadamente
  };

  const BADGE_DESCRIPTIONS_TYPES = {
    Estrutura: {
      badges: [
        'BadgeCautelar',
        'BadgeCautelarBomKm',
        'BadgeLongarina',
        'BadgeLongarinaBomKm',
        'BadgeColunas',
        'BadgeColunasBomKm',
        'BadgeBomKm',
        'BadgeLongarinaColunas',
        'AllStructureBadges',
      ],
      color: '#FFE8D8',
      bgColor: '#FF6C1C',
    },
    Mecânica: {
      badges: ['BadgeCambio', 'BadgeScanner', 'AllMechanicBadges'],
      color: '#BCF738',
      bgColor: '#007E62',
    },
    Visual: {
      badges: ['BadgeInterior'],
      color: '#171C24',
      bgColor: '#BCF738',
    },
    Pneus: {
      badges: ['BadgePneus'],
      color: '#E8F5E8',
      bgColor: '#ffff',
    },
  };

  const BADGE_DESCRIPTIONS_STATUS = {
    BadgeCautelar: shouldShowCautelar && !shouldShowBomKm,
    BadgeCautelarBomKm: shouldShowCautelar && shouldShowBomKm,
    BadgeLongarina: shouldShowLongarina && !shouldShowBomKm && !shouldShowColunas,
    BadgeLongarinaBomKm: shouldShowLongarina && shouldShowBomKm && !shouldShowColunas,
    BadgeColunas: shouldShowColunas && !shouldShowBomKm && !shouldShowLongarina,
    BadgeBomKm:
      shouldShowBomKm && !shouldShowCautelar && !shouldShowColunas && !shouldShowLongarina,
    BadgeColunasBomKm: shouldShowColunas && shouldShowBomKm && !shouldShowLongarina,
    BadgeLongarinaColunas: shouldShowLongarina && shouldShowColunas && !shouldShowBomKm,
    AllStructureBadges: shouldShowLongarina && shouldShowColunas && shouldShowBomKm,
    BadgeCambio: shouldShowCambio && !shouldShowScanner,
    BadgeScanner: shouldShowScanner && !shouldShowCambio,
    AllMechanicBadges: shouldShowCambio && shouldShowScanner,
    BadgePneus: shouldShowPneus, // Nova badge de pneus
    BadgeInterior: shouldShowInterior, // Nova badge de conservação do interior
    BadgeGNV: shouldShowGNV, // Nova badge de GNV
  };

  const BADGE_DESCRIPTIONS = {
    BadgeCautelar: auction?.vehicle?.hasD2D 
      ? 'InstaCarro Cautelar aprovada.' 
      : 'Cautelar aprovada.',
    BadgeCautelarBomKm: auction?.vehicle?.hasD2D 
      ? 'InstaCarro Cautelar aprovada, boa km por ano.' 
      : 'Cautelar aprovada, boa km por ano.',
    BadgeLongarina: 'Longarina sem apontamentos.',
    BadgeLongarinaBomKm: 'Longarina sem apontamentos, boa km por ano.',
    BadgeBomKm: 'Boa km por ano.',
    BadgeColunas: 'Colunas sem apontamentos.',
    BadgeColunasBomKm: 'Colunas sem apontamentos, boa km por ano.',
    BadgeLongarinaColunas: 'Longarina e colunas sem apontamentos.',
    AllStructureBadges: 'Longarina e colunas sem apontamentos, boa km por ano.',
    BadgeCambio: 'Câmbio sem apontamentos.',
    BadgeScanner: 'Scanner sem apontamentos.',
    AllMechanicBadges: 'Câmbio e scanner sem apontamentos.',
    BadgePneus: 'Pneus em condição de rodagem.', // Nova descrição
    BadgeInterior: 'Bom estado de conservação interior.', // Nova descrição
    BadgeGNV: 'Equipado com GNV.', // Nova descrição
  };

  const BADGES = [
    {
      icone: auction?.vehicle?.hasD2D ? CautelarInstaCarro : Cautelar,
      titulo: auction?.vehicle?.hasD2D ? 'Cautelar aprovada' : 'Cautelar aprovada',
      descricao: auction?.vehicle?.hasD2D 
        ? 'Aprovada, pode conter apontamentos' 
        : 'Cautelar Visão total verificada e aprovada',
    },
    {
      icone: Longarina,
      titulo: 'Longarina sem apontamentos',
      descricao: 'Verificada e sem observações',
    },
    {
      icone: Colunas,
      titulo: 'Colunas sem apontamentos',
      descricao: 'Verificadas e sem observações',
    },
    {
      icone: Km,
      titulo: 'Boa km por ano',
      descricao: 'Na média de km para carros do mesmo ano',
    },
    {
      icone: Cambio,
      titulo: 'Câmbio sem apontamentos',
      descricao: 'Teste inerte sem ressalvas',
    },
    {
      icone: Scanner,
      titulo: 'Scanner sem apontamentos',
      descricao: 'Verificado e sem observações',
    },
    {
      icone: BadgePneus, // Nova badge de pneus
      titulo: 'Pneus em condição de rodagem',
    },
    {
      icone: BadgeInterior, // Nova badge de conservação do interior
      titulo: 'Bom estado de conservação interior',
    },
    {
      icone: BadgeGNV, // Nova badge de GNV
      titulo: 'Equipado com GNV',
    },
  ];

  const badgeKeyForStatus = Object.keys(BADGE_STATUS).filter(key => BADGE_STATUS[key]);

  const getTrueBadgesByType = type => {
    const badgeKeyForType = BADGE_TYPES[type] || [];
    const trueBadgesKeys = badgeKeyForStatus.filter(key => badgeKeyForType.includes(key));
    return trueBadgesKeys.reduce((result, key) => {
      // Mapeamento correto dos badges para seus índices no array BADGES
      const badgeIndexMap = {
        BadgeCautelar: 0,
        BadgeLongarina: 1,
        BadgeColunas: 2,
        BadgeBomKm: 3,
        BadgeCambio: 4,
        BadgeScanner: 5,
        BadgePneus: 6,
        BadgeInterior: 7,
        BadgeGNV: 8,
      };
      
      const badgeIndex = badgeIndexMap[key];
      if (badgeIndex !== undefined && BADGES[badgeIndex]) {
        result[key] = BADGES[badgeIndex];
      }
      return result;
    }, {});
  };

  const descriptionKeyForStatus = Object.keys(BADGE_DESCRIPTIONS_STATUS).filter(
    key => BADGE_DESCRIPTIONS_STATUS[key]
  );

  const getTrueDescription = type => {
    const descriptionKeyForType = BADGE_DESCRIPTIONS_TYPES[type];

    if (!descriptionKeyForType) {
      console.warn(`Tipo inválido: ${type}`);
      return [];
    }

    const { badges, color, bgColor } = descriptionKeyForType;

    const trueDescriptionKeys = descriptionKeyForStatus.filter(key => badges.includes(key));

    const descriptions = trueDescriptionKeys.map(key => ({
      description: BADGE_DESCRIPTIONS[key],
      color,
      bgColor,
    }));

    // Tratamento especial para badge GNV na seção Mecânica
    if (type === 'Mecânica' && shouldShowGNV) {
      descriptions.push({
        description: BADGE_DESCRIPTIONS['BadgeGNV'],
        color: '#F3F3EF', // Cor da badge de Pneus
        bgColor: '#8B8D91', // Cor da badge de Pneus
      });
    }

    return descriptions;
  };

  const badgesToDisplay = getTrueBadgesByType(title);
  const descriptionToDisplay = getTrueDescription(title);

  if (!items.length) return null;

  // Verificar se esta é a seção de "Rodas e Pneus"
  const isRodasEPneusSection = title === 'Rodas e Pneus' || title.includes('Pneus') || title.includes('Rodas');

  const useTitleLayout = () => {
    if (!title) return null;

    return (
      <S.Title onClick={() => setOpened(!opened)}>
        <span className="dropdown-list-title">
          {title.includes('Mecanica') ? 'Mecânica' : title}
        </span>

        <Row>
          {/* Exibir badges normais da seção */}
          {Object.entries(badgesToDisplay).map(([key, badge]) => (
            <Image key={key} src={badge.icone} alt={`Badge ${key}`} />
          ))}
          
          {/* Exibir badge de pneus na seção "Rodas e Pneus" - posicionada como "Cautelar aprovada" */}
          {isRodasEPneusSection && shouldShowPneus && (
            <Image src={BadgePneus} alt="Badge Pneus" />
          )}
        </Row>

        {opened ? <MdKeyboardArrowDown size={27} /> : <MdKeyboardArrowUp size={27} />}
      </S.Title>
    );
  };

  const sortedItemsToDisplayWithoutGroup = sortedItems?.texts
    ?.filter(item => item.value && !item.label.includes('>:'))
    .sort((a, b) => a.value.length - b.value.length);

  const sortedItemsToDisplayWithGroup = () => {
    const grouped = Object.values(
      sortedItems?.texts
        ?.filter(item => item.value && item.label.includes('>:'))
        .reduce((acc, item) => {
          const [group, subLabel] = item.label.split('>:').map(s => s.trim());

          if (!acc[group]) {
            acc[group] = { group, items: [] };
          }

          acc[group].items.push({
            label: subLabel,
            value: item.value,
          });

          acc[group].items.sort((a, b) => a.value.length - b.value.length);

          return acc;
        }, {})
    );

    return grouped;
  };

  return (
    <S.Wrapper useNewSort={useNewSort || useNewLayout}>
      {useTitleLayout()}

      {opened && !!sortedItems?.photos?.length ? (
        <React.Fragment>
          {/* Exibir descrições das badges normais - incluindo a de pneus automaticamente */}
          {descriptionToDisplay.map(({ description, color, bgColor }) => (
            <Tooltip key={description} color={color} bgColor={bgColor}>
              {description}
            </Tooltip>
          ))}
          
          {/* Removendo a lógica separada - a badge de pneus será exibida automaticamente */}
          
          {/* Exibir descrição da badge de pneus na seção "Rodas e Pneus" */}
          {isRodasEPneusSection && shouldShowPneus && (
            <Tooltip key="pneus" color="#F3F3EF" bgColor="#8B8D91">
              Pneus em condição de rodagem
            </Tooltip>
          )}

          {onGallery && (
            <u className="see-photos" onClick={onGallery}>
              Ver Fotos
            </u>
          )}
          {!useNewSort && (
            <S.WithoutImage isOptional={isOptional} useGrid>
              {sortedItems?.photos?.map(({ description }) => (
                <span className="onlyText 44" key={description}>
                  {description}
                </span>
              ))}
            </S.WithoutImage>
          )}
        </React.Fragment>
      ) : null}
      {opened && !!sortedItems?.texts?.length && !useNewSort ? (
        <S.WithoutImage isOptional={isOptional} useGrid>
          {sortedItems?.texts?.map(({ description }) => (
            <span className="onlyText" key={description}>
              {description}
            </span>
          ))}
        </S.WithoutImage>
      ) : null}

      {opened && !!sortedItems?.texts?.length && useNewSort ? (
        <S.WithoutImage isOptional={isOptional} useGrid>
          {checkItemsToHaveDivider(sortedItemsToDisplayWithoutGroup)?.map(
            ({ value: { label, value }, useDivider }) => (
              <div key={label} className={useDivider ? 'onlyText' : 'last-item'}>
                <span className="onlyBoldText">{label}</span>
                <span>{': '}</span>
                {value.includes(',') && <br />}
                {value.split(',').map(item => (
                  <>
                    <span key={item} className={!value.includes(',') && 'bold'}>
                      {item.replaceAll(';', ',')}
                    </span>
                    <br />
                  </>
                ))}
              </div>
            )
          )}
        </S.WithoutImage>
      ) : null}
      {opened && !!sortedItems?.texts?.length && useNewSort ? (
        <S.WithoutImage isOptional={isOptional}>
          {sortedItemsToDisplayWithGroup()?.map(({ group, items }, index) => (
            <div
              className={
                index === sortedItemsToDisplayWithGroup().length - 1 ? 'last-item' : 'onlyText'
              }
            >
              <span className="onlyBoldHeader">{group}</span>
              <br />
              <br />
              <S.Group>
                {items.map(({ label, value }) => (
                  <div className="last-item">
                    <span className="onlyBoldText">{label}</span>
                    <span>{': '}</span>
                    {value.includes(',') && <br />}
                    {value.split(',').map(item => (
                      <>
                        <span key={item} className={!value.includes(',') && 'bold'}>
                          {item.replaceAll(';', ',')}
                        </span>
                        <br />
                      </>
                    ))}
                  </div>
                ))}
              </S.Group>
            </div>
          ))}
        </S.WithoutImage>
      ) : null}
    </S.Wrapper>
  );
};

export const Container = ({
  title,
  hideIcon = false,
  color,
  children,
  hideLine = false,
  icon = <FlagIcon color={color} />,
  useNewLayout = false,
}) => {
  return (
    <S.Container>
      <S.Title useNewLayout={useNewLayout}>
        {!hideIcon ? icon : null}
        {title && <span className="group-title">{title}</span>}
      </S.Title>
      {children}
      {!hideLine ? <S.Divider /> : null}
    </S.Container>
  );
};

export const NewSection = {
  Container,
  Content,
};
